import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "card h-100" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "card h-100" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 d-flex justify-content-between py-3 align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h3", null, "Activate Cheat Mode", -1)
const _hoisted_17 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, "Cheat Mode", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "card h-100" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("h3", { class: "mb-0" }, "Role Access Management")
], -1)
const _hoisted_24 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_RoleAccessSection = _resolveComponent("RoleAccessSection")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      title: "Konfigurasi",
      link1: "Konfigurasi"
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configs, (config, i) => {
                return (_openBlock(), _createBlock("div", {
                  class: "col-12 d-flex justify-content-between py-3",
                  key: i,
                  style: {"border-bottom":"1px solid #e9ecef"}
                }, [
                  _createVNode("div", null, _toDisplayString(config.conf_name.replace(/_/g, ' ').toUpperCase().slice(4)), 1),
                  _createVNode("div", null, [
                    (config.conf_isBoolean == 1)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          (_ctx.canUpdate)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 0,
                                type: "radio",
                                id: 'true-' + i,
                                value: "true",
                                "onUpdate:modelValue": ($event: any) => (config.conf_value = $event),
                                class: "me-1"
                              }, null, 8, ["id", "onUpdate:modelValue"])), [
                                [_vModelRadio, config.conf_value]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.canUpdate)
                            ? (_openBlock(), _createBlock("label", {
                                key: 1,
                                for: 'true-' + i,
                                class: "me-2"
                              }, " True", 8, ["for"]))
                            : _createCommentVNode("", true),
                          (_ctx.canUpdate)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 2,
                                type: "radio",
                                id: 'false-' + i,
                                value: "false",
                                "onUpdate:modelValue": ($event: any) => (config.conf_value = $event),
                                class: "me-1"
                              }, null, 8, ["id", "onUpdate:modelValue"])), [
                                [_vModelRadio, config.conf_value]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.canUpdate)
                            ? (_openBlock(), _createBlock("label", {
                                key: 3,
                                for: 'false-' + i
                              }, "False", 8, ["for"]))
                            : _createCommentVNode("", true),
                          (!_ctx.canUpdate)
                            ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(config.conf_value), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_8, [
                          (_ctx.canUpdate)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 0,
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => (config.conf_value = $event),
                                class: "form-control form-control-sm"
                              }, null, 8, ["onUpdate:modelValue"])), [
                                [
                                  _vModelText,
                                  config.conf_value,
                                  void 0,
                                  { lazy: true }
                                ]
                              ])
                            : _createCommentVNode("", true),
                          (!_ctx.canUpdate)
                            ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(config.conf_value), 1))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                (_ctx.canUpdate)
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "flexSwitchCheckDefault",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.cheatMode = $event)),
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.activateCheatMode && _ctx.activateCheatMode(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.cheatMode]
                      ]),
                      _hoisted_18
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.canUpdate)
                  ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.cheatMode ? 'Aktif' : 'Tidak Aktif'), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isRoleAccessEnabled)
      ? (_openBlock(), _createBlock("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_RoleAccessSection)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}